<template>
  <ul
    v-if="normalizedProductAvailability.length > 0"
    class="product-stock-debug"
  >
    <li
      v-for="(item, itemIndex) in normalizedProductAvailability"
      :key="`item-${itemIndex}`"
    >
      <template v-for="subItem in item">
        <span
          v-for="(value, propertyName) in subItem"
          :key="`${propertyName}-${value}`"
          :class="{
            highlighted:
              otcBranchName &&
              propertyName &&
              propertyName.toLowerCase().includes(otcBranchName),
          }"
          >{{ propertyName }}:<strong>{{ value }}</strong></span
        >
      </template>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ProductAvailability',
  props: {
    productAvailability: {
      type: [Array, Object],
      default: () => [],
    },
  },
  computed: {
    ...mapState('core', {
      salesChannelId: ({ salesChannel }) => salesChannel.salesChannelId,
    }),
    otcBranchName() {
      if (!this.salesChannelId || !this.salesChannelId.includes('otc_branch')) {
        return null;
      }
      const branchMatch = this.salesChannelId.match(/otc_branch(\d+)/);
      return branchMatch ? `f${branchMatch[1]}` : null;
    },
    normalizedProductAvailability() {
      const source = this.productAvailability;

      if (!source || typeof source !== 'object') {
        return [];
      }

      const groups = Array.isArray(source) ? source : Object.values(source);

      return groups.flatMap((group) => {
        if (!Array.isArray(group)) {
          return [];
        }

        const validEntries = group.filter(
          (entry) => entry && typeof entry === 'object' && !Array.isArray(entry)
        );

        return validEntries.length ? [validEntries] : [];
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import 'mixins';
@import 'variables/breakpoints';

.product-stock-debug {
  margin-top: var(--space-3);
  display: inline-block;
  width: 100%;

  li {
    display: inline-block;
    font-size: var(--font-size-SM);
    color: var(--color-rhino-without-horn);
    text-transform: uppercase;

    & + li::before {
      content: '';
      width: 1px;
      height: 12px;
      background: var(--color-black);
      display: inline-block;
      position: relative;
      margin-left: var(--space-1);
      margin-right: var(--space-1);
      top: 1px;
    }

    > span:not(:last-child) {
      margin-right: var(--space-1);
    }

    .highlighted {
      color: var(--color-primary);
    }

    strong {
      font-weight: bold;
    }
  }
}
</style>
